import React from 'react'
import { Link } from 'react-router-dom'


const NotFoundPage = () => {
  return (
    <div className='PrivacyPolicy container '>
     
            <div className='text-center '>
       <h3>PRIVACY POLICY</h3>
       </div>
<h6>Last updated Feb 09, 2025</h6>

<div className='text-justify'>

<p  style={{lineHeight:"normal"}} >Swaminarayan University offers a way to develop the mobile application and ERP system for the universities through the software department team. These terms and conditions apply to the SUK student login, SUK Audit App, SUK Courses, SUK Dashboard, Swaminarayan University Exam, SUK Evaluator, SUK Exam app (hereby referred to as "Application") for mobile devices that was created by Marwadi Technologies (hereby referred to as "Service Provider", “we”, “us”, “our”) as a Free service. This Privacy Policy applies to all of our Services unless specified otherwise. <br /><br />
Upon downloading or utilizing the Application, you are automatically agreeing to the following terms. It is strongly advised that you thoroughly read and understand these terms prior to using the Application. Unauthorized copying, modification of the Application, any part of the Application, or our trademarks is strictly prohibited. Any attempts to extract the source code of the Application, translate the Application into other languages, or create derivative versions are not permitted. All trademarks, copyrights, database rights, and other intellectual property rights related to the Application remain the property of the Service Provider.<br /><br />
The Service Provider is dedicated to ensuring that the Application is as beneficial and efficient as possible. As such, they reserve the right to modify the Application or charge for their services at any time and for any reason. The Service Provider assures you that any charges for the Application or its services will be clearly communicated to you. <br /><br />
The Application stores and processes personal data that you have provided to the Service Provider to provide the Service. It is your responsibility to maintain the security of your phone and access to the Application. The Service Provider strongly advise against jailbreaking or rooting your phone, which involves removing software restrictions and limitations imposed by the official operating system of your device. Such actions could expose your phone to malware, viruses and malicious programs, compromise your phone's security features, and may result in the Application not functioning correctly or at all.<br /><br />
Please note that the Application utilizes third-party services that have their own Terms and Conditions. Below are the links to the Terms and Conditions of the third-party service providers used by the Application:
</p>

<ul>
  <li><a href="https://policies.google.com/terms" target='_blank'>Google Play Services</a></li>
  <li><a href="https://www.google.com/analytics/terms/" target='_blank'>Google Analytics for Firebase</a></li>
  <li><a href="https://firebase.google.com/terms/crashlytics" target='_blank'>Firebase Crashlytics</a></li>
</ul>

<p  style={{lineHeight:"normal"}}>
The Service Provider may wish to update the application at some point. The application is currently available as per the requirements for the operating system (and for any additional systems they decide to extend the availability of the application to) may change, and you will need to download the updates if you want to continue using the application. The Service Provider does not guarantee that it will always update the application so that it is relevant to you and/or compatible with the particular operating system version installed on your device. However, you agree to always accept updates to the application when offered to you. The Service Provider may also wish to cease providing the application and may terminate its use at any time without providing termination notice to you. Unless they inform you otherwise, upon any termination, (a) the rights and licenses granted to you in these terms will end; (b) you must cease using the application, and (if necessary) delete it from your device. <br /><br />

<strong>Access to This Information</strong> Only administrators have access to the logged network requests from our services. The log may be shared with others to aid in debugging, but any Personal Information will be removed before that. Encrypted backups of our services may be shared with our selected core developers. The keys and the backups themselves are given to different people, requiring at least two core developers to read a backup. We may be required to share information with the law enforcement of the nations hosting our servers. <br /><br />
<strong>Examples of how we collect data this way</strong> We collect this personal data this way by using: <br /><br />
Cookies Server logs and Other similar technologies
What data do we collect this way: Technical Data Profile Data Usage Data <br /><br />
<strong>Information We Collect </strong><br /><br />
<strong>
Personal Information:</strong> We may collect personal information that you provide to us directly when you use our App. This may include: <br /><br />

</p>

<ul>
  <li>More recent product features and functionalities are now included.</li>
  <li>Enhanced details on how we process your data for safety, security, and integrity.</li>
  <li>Added direct links and permissions used for the mobile app are also provided.</li>
</ul>
<p>
<strong>Non-Personal Information:</strong> We may also collect non-personal information about your use of the App, such as:
</p>

<ul>
  <li>Device information (e.g., type, model, operating system version)</li>
  <li>Usage data (e.g., feature usage, interactions with the App)</li>
  <li>Analytics data (e.g., performance metrics, error logs)</li>
</ul>

<p>
<strong>How We Use Your Information </strong> <br />
We may use the information we collect for various purposes, including:

</p>

<ul>
  <li>To provide, operate, and maintain the App</li>
  <li>To improve, personalize, and optimize the App</li>
  <li>To detect, prevent, and address technical issues</li>
</ul>
<p>
<strong>How We Share Your Information</strong> <br />
We may share your information with third parties only in the following circumstances:

</p>
<ul>
  <li>With your consent</li>
  <li>To comply with legal obligations</li>
  <li>To protect and defend our rights and property</li>
</ul>

<p style={{lineHeight:"normal"}}>
<strong>Security of Your Information</strong> <br />
We take reasonable measures to protect the information we collect from unauthorized access or disclosure. However, no method of transmission over the internet or electronic storage is completely secure. <br /><br />

<strong>Links to Other Sites</strong> <br />
The app may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services. <br /><br />
<strong>Children’s Privacy</strong> <br />

Our App does not knowingly collect personal information from children under the age of 13. If we discover that we have collected personal information from a child under 13, we will take steps to delete such information.

Changes to This Privacy Policy
We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes. <br /><br />
These terms and conditions are effective as of 2025-02-19 <br /><br />
<strong>Contact Us</strong> <br />
If you have any questions about this Privacy Policy, please contact us at  <a href="mailto:itmanager@swaminarayanuniversity.ac.in">itmanager@swaminarayanuniversity.ac.in</a>

</p> <br /><br />
</div>

        <div className='text-center'>
    <Link to={"/"} className="btn default-btn">
      Back To Homepage
    </Link> 
    </div>
    <br /><br />
    </div>
    
  )
}

export default NotFoundPage